"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var ladda_directive_1 = require("./ladda.directive");
var ladda_config_1 = require("./ladda-config");
var LaddaModule = LaddaModule_1 = (function () {
    function LaddaModule() {
    }
    LaddaModule.forRoot = function (config) {
        return {
            ngModule: LaddaModule_1,
            providers: [
                { provide: ladda_config_1.LaddaConfig, useValue: config }
            ]
        };
    };
    return LaddaModule;
}());
LaddaModule = LaddaModule_1 = __decorate([
    core_1.NgModule({
        declarations: [ladda_directive_1.LaddaDirective],
        exports: [ladda_directive_1.LaddaDirective],
    })
], LaddaModule);
exports.LaddaModule = LaddaModule;
var LaddaModule_1;
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-ladda/module/module.js
// module id = 583
// module chunks = 7